export default "__VITE_ASSET__CGHzvdRF__"